import { render, staticRenderFns } from "./MetaboliteAdd.vue?vue&type=template&id=7fc8f9ce&"
import script from "./MetaboliteAdd.vue?vue&type=script&lang=js&"
export * from "./MetaboliteAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports